import { ReactNode, Component } from "react"

import moment from "moment"

import PersonUpdate from '../person/PersonUpdate'
import PersonAdd from '../person/PersonAdd'
import CompanyAddUpdate from '../company/CompanyAddUpdate'

import { Person } from "../../../libs/user/Person"
import { Company } from "../../../libs/user/Company"

import Radio from "../../../libs/ui/inputs/Radio"

import { DATE_FORMAT } from "../../../libs/validation/dateValidation"

interface SelectContractorProps {
    peopleList: Person[] | undefined
    companyList: Company[] | undefined

    value: string | undefined

    profList?: any | undefined
    statiList?: any | undefined
    
    callback?: Function
    updateUserCallBack?: Function
    expiredSessionCallbak: Function

    hideProfessione?: boolean
}

class SelectContractor extends Component<SelectContractorProps> {
    
    constructor (porps: any) {
        super (porps)

        this.isChecked = this.isChecked.bind(this)
        this.getProfessioneLabel = this.getProfessioneLabel.bind(this)
    }

    render(): ReactNode {
        return (
            <>  
                {this.props.peopleList &&
                    <>
                        {
                            this.props.peopleList?.map ((ele, index) => {
                                const dateOfBirth = (typeof ele.dateOfBirth === 'string' || typeof ele.dateOfBirth === 'undefined' ) 
                                    ? ele.dateOfBirth
                                    : moment(ele.dateOfBirth).format(DATE_FORMAT);

                                const notValid = ele.errors !== undefined && ele.errors.length > 0

                                const key = ele.id ?? index

                                return (
                                    <div className="form-group radioOption" key={key}>
                                        <Radio
                                            id={ele.id?.toString()}
                                            value={ele.id}
                                            checked={ 
                                                this.isChecked(
                                                    (ele.id ?? '').toString()
                                                )
                                            }
                                            disabled= { notValid }
                                            callback={this.props.callback}
                                        >
                                            <span>
                                                <strong className="contractorTitle">{ele.name} {ele.surname}</strong><br/>
                                                <span>
                                                    { notValid && 
                                                        <span className="radio_label_error_list">  Modifica: 
                                                            {
                                                                ele.errors?.map( (er, index) => {
                                                                    return <span 
                                                                        key={key + '_error_' + index}
                                                                        className="radio_label_error"
                                                                    >
                                                                        {er}, 
                                                                    </span>
                                                                })
                                                            }
                                                        </span>
                                                    }
                                                    { ele.gender &&
                                                        <>
                                                            {ele.gender}, data di nascita {dateOfBirth ?? '-'}<br/>
                                                        </>
                                                    }
                                                    { this.props.hideProfessione !== true &&
                                                        <>
                                                            Professione: {this.getProfessioneLabel(ele.profession)}<br/>
                                                        </>
                                                    }
                                                    { ele.bornInItaly && ele.cityOfBirth &&
                                                        <>
                                                            Comune di nascita: {ele.cityOfBirth.value}
                                                        </>
                                                    }
                                                    { ele.countryOfBirth?.value && (!ele.bornInItaly || ele.bornInItaly === null) &&
                                                        <>
                                                            Paese di nascita: {ele.countryOfBirth?.value}
                                                        </>
                                                    }
                                                </span>

                                                <PersonUpdate 
                                                    person={ele}
                                                    profList={this.props.profList}
                                                    statiList={this.props.statiList}
                                                    callbackUser={this.props.updateUserCallBack}
                                                    expiredSessionCallbak={this.props.expiredSessionCallbak}

                                                    hideProfessione={this.props.hideProfessione}
                                                />
                                            </span>
                                        </Radio>
                                    </div>
                                )
                            })
                        }
                        <PersonAdd 
                            profList={this.props.profList}
                            statiList={this.props.statiList}
                            callbackUser={this.props.updateUserCallBack}
                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                            hideProfessione={this.props.hideProfessione}
                        />
                    </>
                }
                {this.props.companyList &&
                    <>
                        {
                            this.props.companyList?.map ((ele, index) => {
                                return (
                                    <div className="form-group radioOption" key={ele.id ?? index}>
                                        <Radio
                                            id={ele.id?.toString()}
                                            value={ele.id}
                                            checked={ 
                                                this.isChecked(
                                                    (ele.id ?? '').toString()
                                                )
                                            }
                                            callback={this.props.callback}
                                        >
                                            <span>
                                                <strong className="contractorTitle">{ele.legal_name}</strong><br/>
                                                <span>
                                                    {ele.vat}<br/>
                                                </span>
                                                <span>
                                                    Referente: {ele.referent_first_name} {ele.referent_last_name}
                                                </span>

                                                <CompanyAddUpdate 
                                                    company={ele}
                                                    profList={undefined}
                                                    statiList={undefined}
                                                    callbackUser={this.props.updateUserCallBack}
                                                    expiredSessionCallbak={this.props.expiredSessionCallbak}
                                                />
                                            </span>
                                        </Radio>
                                    </div>
                                )
                            }) 
                        }
                        <CompanyAddUpdate 
                            profList={undefined}
                            statiList={undefined}
                            callbackUser={this.props.updateUserCallBack}
                            expiredSessionCallbak={this.props.expiredSessionCallbak}
                        />
                    </>
                }
            </>
        )
    }

    private isChecked (id: string) {
        return id === this.props.value
    }

    private getProfessioneLabel (key: string | undefined) {
        if (key && this.props.profList) {
            const find = this.props.profList.filter(
                (p: any) => p.id === key
            )
            return (find) ? find[0]?.value : undefined
        }
        return undefined
    }
    
}

export default SelectContractor